import { useState } from "react";
import { ContainerAutorizacionOrden } from "./localStyle";
import ordenImage from "_+_Portal/assets/images/generico/OrdenMiniatura.png";
import { Camera, CameraResultType } from "@capacitor/camera";

const AutorizacionOrden = ({ finalizarProceso, idTurno }) => {
  const [step, setStep] = useState("tomarFoto"); // tomarFoto confirmacionOrden
  const [imageCamera, setImageCamera] = useState([]);

  const subirAutorizacion = () => {
    const takePicture = async () => {
      const image = await Camera.getPhoto({
        quality: 90,
        allowEditing: true,
        resultType: CameraResultType.DataUrl,
      });
      let lista = [...imageCamera];
      lista[0] = {
        base64: image.dataUrl.replaceAll(
          `data:image/${image.format};base64,`,
          ""
        ),
        type: image.format,
      };
      setImageCamera(lista);
      setStep("confirmacionOrden");
    };
    takePicture();
  };

  const handleClickConfirmarOrden = (isCorrect) => {
    if (isCorrect) {
      const dto = {
        binario: imageCamera[0].base64,
        idRemoto: idTurno,
        tag: imageCamera[0].type,
        autocheck: true,
      };
      finalizarProceso(dto, "autorizacionOrden");
    } else {
      setStep("tomarFoto");
    }
  };

  const renderStep = () => {
    switch (step) {
      case "tomarFoto":
        return (
          <ContainerAutorizacionOrden>
            <span>Imagen de autorización</span>
            <span>
              El turno requiere autorización, ingrese una imagen de la misma.
            </span>
            <img
              className="first-image"
              src={ordenImage}
              alt="ordenes de autocheckin"
            />
            <div className="container-btn">
              <button
                onClick={() => subirAutorizacion()}
                className="bgc-primary"
              >
                Subir Autorización
              </button>
            </div>
          </ContainerAutorizacionOrden>
        );
      case "confirmacionOrden":
        return (
          <ContainerAutorizacionOrden>
            <span>Imagen de autorización</span>
            <span>
              El turno requiere autorización, ingrese una imagen de la misma.
            </span>
            <img
              className="first-image"
              src={`data:image/${imageCamera[0].type};base64,${imageCamera[0].base64}`}
              alt="ordenes de autocheckin"
            />
            <div className="btn-container">
              <button
                onClick={() => handleClickConfirmarOrden(false)}
                className="bgc-danger"
              >
                NO
              </button>
              <button
                onClick={() => handleClickConfirmarOrden(true)}
                className="bgc-broccoli"
              >
                SI
              </button>
            </div>
          </ContainerAutorizacionOrden>
        );
      default:
        return <h1>Estas ahdjlashdljas</h1>;
    }
  };

  return renderStep();
};

export default AutorizacionOrden;
